import { createAction } from '@reduxjs/toolkit';

/**
 * The picklist line a server 409 left open was chosen; the pick goes again
 * with it. Apart from the slice because a thunk sends it too.
 */
export const pickingLineSwitched = createAction('operatorPicking/lineSwitched');
